import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import VacationDetailsModal from './VacationDetailsModal';
import VacationRequestForm from './VacationRequestForm';
import VacationRequestsTable from './VacationRequestsTable';
import VacationSummary from './VacationSummary';


const VacationSection = ({ perfil }) => {
    const [saving, setSaving] = useState(false);
    const { token } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();
    const [selectedDates, setSelectedDates] = useState({ startDate: '', endDate: '' });
    const [selectedDaysList, setSelectedDaysList] = useState([]); // Nueva: lista de días seleccionados
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedVacation, setSelectedVacation] = useState(null);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [calculoVacaciones, setCalculoVacaciones] = useState({
        diasTotales: 0,
        diasUtilizados: 0,
        diasDisponibles: 0,
        aniosServicio: 0,
        desglosePorAnio: []
    });

    /**
     * Carga el cálculo de vacaciones desde el backend
     */
    const loadCalculoVacaciones = async () => {
        try {
            const response = await fetch(`/api/vacaciones/CalcularDiasVacacionesLFT?idUsuario=${perfil.idUsuario}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();

            if (data.iResponseType === 1 && data.detalles) {
                const detalles = JSON.parse(data.detalles);

                // ✅ CORRECCIÓN: El SP retorna table2 y table3, NO table1 y table2
                // Table[2]: Información General (con días proporcionales)
                const resumen = detalles.table2?.[0] || detalles.Table2?.[0];

                // Table[3]: Desglose por Período/Año
                const desglose = detalles.table3 || detalles.Table3 || [];

                if (resumen) {
                    setCalculoVacaciones({
                        diasTotales: resumen.iDiasTotalesAcumulados || 0,
                        diasUtilizados: resumen.iDiasUtilizados || 0,
                        diasDisponibles: resumen.iDiasDisponibles || 0,
                        aniosServicio: resumen.iAniosServicio || 0,
                        proximoAniversario: resumen.dProximoAniversario || null,
                        diasHastaProximoAniversario: resumen.iDiasHastaProximoAniversario || 0,
                        estadoAniosServicio: resumen.vEstadoAniosServicio || '',
                        desglosePorAnio: Array.isArray(desglose) ? desglose.map(d => ({
                            iAnio: d.iAnio || 0,
                            vDescripcionAnio: d.vDescripcionAnio || `Año ${d.iAnio}`,
                            dFechaInicio: d.dFechaInicio || '',
                            dFechaFin: d.dFechaFin || '',
                            iDiasGenerados: d.iDiasGenerados || 0,
                            iDiasUtilizados: d.iDiasUtilizados || 0,
                            iDiasDisponibles: d.iDiasDisponibles || 0,
                            bPeriodoActivo: d.bPeriodoActivo || false,
                            bPeriodoCompletado: d.bPeriodoCompletado || false,
                            decPorcentajeAvance: d.decPorcentajeAvance || 0,
                            vEstadoPeriodo: d.vEstadoPeriodo || 'Desconocido'
                        })) : []
                    });
                }
            }
        } catch (error) {
            console.error('Error al cargar cálculo de vacaciones:', error);
        }
    };

    useEffect(() => {
        if (perfil && perfil.idUsuario) {
            loadCalculoVacaciones();
        }
    }, [perfil]);

    const formatDate = (dateString) => {
        if (!dateString) return '-';

        try {
            const date = new Date(dateString);

            if (!isNaN(date.getTime())) {
                return date.toLocaleDateString('es-ES', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                });
            }

            return dateString;
        } catch (error) {
            return dateString || '-';
        }
    };

    /**
     * Envía la solicitud de vacaciones con la lista exacta de días seleccionados
     */
    const requestVacation = async () => {
        setSaving(true);
        try {
            // Validar que haya días seleccionados
            if (!selectedDaysList || selectedDaysList.length === 0) {
                throw new Error('Debes seleccionar al menos un día para solicitar vacaciones');
            }

            // Extraer solo las fechas en formato string (YYYY-MM-DD)
            const fechasSolicitadas = selectedDaysList.map(day => day.dateString);

            // Request body simplificado - SOLO fechasSolicitadas e idUsuario
            const requestBody = {
                solicitud: {
                    idUsuario: perfil.idUsuario.toString(),
                    fechasSolicitadas: fechasSolicitadas
                }
            };

            console.log('Enviando solicitud con fechas:', requestBody);

            const response = await fetch("/api/vacaciones/SolicitarVacaciones", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();

            if (data.iResponseType === 1) {
                // Limpiar formulario
                setSelectedDates({ startDate: '', endDate: '' });
                setSelectedDaysList([]);


                showSuccessToast(data.vMessage || 'Solicitud de vacaciones enviada exitosamente');


                // Rec cargar datos
                loadCalculoVacaciones();
                setRefreshTrigger(prev => prev + 1);
            } else {
                throw new Error(data.vMessage || 'Error al procesar la solicitud de vacaciones');
            }
        } catch (error) {

            showErrorToast('Error al procesar la solicitud: ' + error.message);
        } finally {
            setSaving(false);
        }
    };

    const handleVacationClick = (vacationData) => {
        setSelectedVacation(vacationData);
        setShowDetailsModal(true);
    };

    const handleModalSuccess = () => {
        loadCalculoVacaciones();
        setRefreshTrigger(prev => prev + 1);
        showSuccessToast('Operación realizada exitosamente');

    };

    return (
        <Card className="mb-3">
            <Card.Header className="bg-light">
                <h5 className="mb-0">
                    <FontAwesomeIcon icon="umbrella-beach" className="me-2" />
                    Gesti&oacute;n de Vacaciones
                </h5>
            </Card.Header>
            <Card.Body>
                <Row className="g-3 mb-4">
                    <Col md={6}>
                        <VacationSummary
                            calculoVacaciones={calculoVacaciones}
                            perfil={perfil}
                            formatDate={formatDate}
                        />
                    </Col>
                    <Col md={6}>
                        <VacationRequestForm
                            selectedDates={selectedDates}
                            setSelectedDates={setSelectedDates}
                            selectedDaysList={selectedDaysList}
                            setSelectedDaysList={setSelectedDaysList}
                            calculoVacaciones={calculoVacaciones}
                            requestVacation={requestVacation}
                            saving={saving}
                        />
                    </Col>
                </Row>

                <VacationRequestsTable
                    perfil={perfil}
                    onVacationClick={handleVacationClick}
                    refreshTrigger={refreshTrigger}
                    formatDate={formatDate}
                />
            </Card.Body>

            <VacationDetailsModal
                show={showDetailsModal}
                onHide={() => setShowDetailsModal(false)}
                employee={selectedVacation}
                onSuccess={handleModalSuccess}
                showActions={true}
            />
        </Card>
    );
};

VacationSection.propTypes = {
    perfil: PropTypes.object.isRequired
};

export default VacationSection;
